export const state = {
  highlightAttachments: false,
}

export const getters = {
  getHighlightAttachments: (state) => {
    return state.highlightAttachments
  },
}

export const mutations = {
  SET_HIGHLIGHT_ATTACHMENTS(state, payload) {
    state.highlightAttachments = payload
  },
}

export const actions = {
  setHighlightAttachments({ commit, state }, payload) {
    commit('SET_HIGHLIGHT_ATTACHMENTS', payload)
    return payload
  },
}
